<template>
    <div
        v-if="!adDismissed && renderModal"
        class="modal is-active master-pricer-ad-modal"
        style="display: block; z-index: 50;"
    >
        <div
            class="modal-background"
            :style="{
                opacity: modalBackgroundOpacity
            }"
        />
        <div
            class="master-pricer-ad-content"
            :style="{
                top: `${modalCardTop}px`
            }"
        >
            <div class="modal-card">
                <div class="modal-card-body">
                    <div
                        class="is-flex is-flex-direction-column is-align-items-center has-text-centered"
                        style="gap: 1.5rem;"
                    >
                        <figure
                            v-if="avatar"
                            class="image is-64x64"
                        >
                            <img
                                :src="avatar"
                                class="is-rounded"
                            >
                        </figure>
                        <div class="content">
                            <slot />
                            <form
                                @submit.prevent="onSubmit"
                            >
                                <div class="buttons">
                                    <button
                                        v-if="$slots['action']"
                                        class="button is-medium is-primary is-fullwidth"
                                        type="submit"
                                        :disabled="searching"
                                        :class="{'is-loading': searching}"
                                    >
                                        <slot name="action" />
                                    </button>
                                    <button
                                        class="button is-primary is-inverted is-fullwidth"
                                        :class="{
                                            'is-small': $slots['action']
                                        }"
                                        style="margin-bottom: 0;"
                                        type="button"
                                        :disabled="searching"
                                        @click="dismiss()"
                                    >
                                        <span>Continue with current search</span>
                                    </button>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import {axios, moment} from "@master";

export default {
    components: {
    },
    props: {
        search: {
            type: Object,
            default: null
        },
        adId: String,
        avatar: {
            type: String,
            required: false
        },
        filters: {
            type: Object,
            default: () => {}
        }
    },
    data() {
        return {
            adDismissed: false,
            renderModal: false,
            modalBackgroundOpacity: 0,
            modalCardTop: '100%',
            searching: false,
            tripType: '',
            cabin: "economy",
            directOnly: false,
            adult: 1,
            child: 0,
            infant: 0,
            segments: [],
            includeBasicEconomy: false,
            airOperator: null
        };
    },
    methods: {
        dismiss() {
            window.localStorage.setItem(this.adId, true);
            this.renderModal = false;
            this.adDismissed = true;
        },
        scrollListener() {
            const start_threshold = 400;
            const end_threshold = 400;

            if(this.adDismissed) {
                return;
            }

            this.modalBackgroundOpacity = (window.scrollY - start_threshold) / end_threshold;
            if(this.modalBackgroundOpacity >= 1) {
                this.modalBackgroundOpacity = 1;
            }

            this.renderModal = (window.scrollY - start_threshold) > 0;

            this.modalCardTop = (window.innerHeight - window.scrollY);
            if(this.modalCardTop <= 0) {
                this.modalCardTop = 0;
            }
        },
        onSubmit() {
            console.log(this.search.segments)
            let segments = this.search.segments.map(segment => {
                console.log(segment.departure.value, segment.arrival.value, segment.departureDate, segment.returnDate);
                let seg = {
                    departure: segment.departure ? segment.departure.value : null,
                    arrival: segment.arrival ? segment.arrival.value : null,
                    departureDate: segment.departureDate ? moment(segment.departureDate).format('YYYY-M-D') : null
                };
                if(this.search.tripType === 'round') {
                    seg['returnDate'] = segment.returnDate ? moment(segment.returnDate).format('YYYY-M-D') : null;
                }
                return seg;
            });

            const payload = {
                tripType: this.search.tripType,
                cabinClass: this.search.cabin,
                directFlightsOnly: this.search.directOnly,
                adult: this.search.adult,
                child: this.search.child,
                infant: this.search.infant,
                segments: segments,
                includeBasicEconomy: this.search.includeBasicEconomy,
                airOperator: this.search.airOperator,
            };

            this.searching = true;
            this.dismiss();

            axios.post('/air', payload)
                .then(response => {
                    this.gaEvent('engagement', 'search', 'Quick Quote Search', {
                        'dimension2': segments[0].departure,
                        'dimension3': segments[0].arrival,
                        'dimension5': this.tripType
                    });
                    this.dismiss();
                    window.location.href = `/air/${response.data.searchId}`;
                }).catch(error => {
                    console.log(error)
                });
        }
    },
    mounted() {
        this.adDismissed = window.localStorage.getItem(this.adId) === 'true' || window.localStorage.getItem(this.adId) === true;

        window.addEventListener('scroll', this.scrollListener);

        if(this.adDismissed) {
            window.removeEventListener('scroll', this.scrollListener);
        }

        // this.tripType = this.search.tripType;
        // this.cabin = this.search.cabin;
        // this.directOnly = this.search.directFlightsOnly;
        // this.adult = this.search.adult;
        // this.child = this.search.child;
        // this.infant = this.search.infant;
        // this.segments = this.search.segments;
        // this.includeBasicEconomy = this.search.includeBasicEconomy;
        // this.airOperator = this.search.airOperator;

        for(let key in this.filters) {
            this.search[key] = this.filters[key];
        }
    }
}
</script>

<style scoped lang="scss">
.master-pricer-ad-modal {
    .master-pricer-ad-content {
        position: absolute;
        left: 0;
        width: 100%;
        height: 100%;
        display: flex;
        align-items: center;
    }
    .modal-card {
        width: 425px;
    }
    p {
        text-wrap-style: pretty;
    }
}
</style>
